import { Pipe, PipeTransform } from '@angular/core';

import { OPTIONS_STATUS } from 'app/app.types';

type LabelOption = { label: string; value: string | number };

@Pipe({
    name: 'label',
    standalone: false
})
export class LabelPipe implements PipeTransform {
    private readonly _defaultMap: Record<string, string> = [...OPTIONS_STATUS, { label: 'Pending', value: 'PENDING' }]
        .reduce((acc, item) => {
            acc[String(item.value)] = item.label;
            return acc;
        }, {} as Record<string, string>);

    transform(value: string | number | null | undefined, options?: LabelOption[] | Record<string, string>): string {
        if (value === null || value === undefined) {
            return '';
        }

        const key = String(value);

        if (Array.isArray(options)) {
            const found = options.find((item) => String(item.value) === key);
            return found?.label ?? key;
        }

        if (options && typeof options === 'object') {
            return options[key] ?? key;
        }

        return this._defaultMap[key] ?? key;
    }
}
